import { useYieldCallback } from '@zillow/yield-callback';

import { useGlobalStoreState } from '../../contexts/GlobalStoreProvider';
import { AllHopsPlacements } from '../../types/genericTypes';
import { handleSignInClick } from '../GatedHomeRecs/gatedCollectionUtils';

export const useGetOMPTopSlotPlacement = () => {
    const { onsiteMessages } = useGlobalStoreState();
    const additionalOMPTopPlacementProps: Record<string, unknown> = {};

    const selectedOMPTopPlacementComponent = onsiteMessages?.messages?.find(
        (message) =>
            message?.placementName === AllHopsPlacements.HOME_PAGE_TOP_SLOT &&
            !!message.selectedTreatment
    );

    const yieldedHandleSignInClick = useYieldCallback(handleSignInClick);
    if (selectedOMPTopPlacementComponent?.selectedTreatment?.component === 'HomepageValuePropCTA') {
        additionalOMPTopPlacementProps.onAction = yieldedHandleSignInClick;
    }

    return {
        selectedOMPTopPlacementComponent,
        additionalOMPTopPlacementProps,
    };
};
